import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ca8d0f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-manager" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加赏品")
const _hoisted_5 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "ms-auto text-muted" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "该赏品在池子中的数量", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "数字越小越靠前", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_3, "已配置 " + _toDisplayString(_ctx.items.length) + " 种赏品", 1)
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: _ctx.onAddItem
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.sortedItems,
      "row-config": { isHover: true },
      "max-height": "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          title: "排序",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.sort_order), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "商品图片",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.product?.image)
              ? (_openBlock(), _createBlock(_component_el_image, {
                  key: 0,
                  src: row.product.image,
                  "preview-src-list": [row.product.image],
                  fit: "cover",
                  style: {"width":"50px","height":"50px"}
                }, null, 8, ["src", "preview-src-list"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "商品名称",
          width: "200"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.product?.name || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "回收价",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.product?.recycle_price ? Number(row.product.recycle_price).toFixed(2) + '元' : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "数量",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.quantity), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "150",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              link: "",
              onClick: ($event: any) => (_ctx.onEditItem(row))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              link: "",
              onClick: ($event: any) => (_ctx.onDeleteItem(row))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: _ctx.isEditingItem ? '编辑赏品' : '添加赏品',
      width: "500px",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSaveItem
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "itemFormRef",
          model: _ctx.itemForm,
          rules: _ctx.itemRules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "商品",
              prop: "product_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.itemForm.product_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemForm.product_id) = $event)),
                  placeholder: "搜索商品",
                  filterable: "",
                  remote: "",
                  "remote-method": _ctx.searchProducts,
                  loading: _ctx.productSearchLoading,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productOptions, (product) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: product.id,
                        label: `${product.name} (回收价: ${Number(product.recycle_price).toFixed(2)}元)`,
                        value: product.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            (product.image)
                              ? (_openBlock(), _createBlock(_component_el_image, {
                                  key: 0,
                                  src: product.image,
                                  fit: "cover",
                                  style: {"width":"30px","height":"30px","margin-right":"8px"}
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(product.name), 1),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(Number(product.recycle_price).toFixed(2)) + "元", 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "remote-method", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "数量",
              prop: "quantity"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.itemForm.quantity,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemForm.quantity) = $event)),
                  min: 1,
                  max: 9999
                }, null, 8, ["modelValue"]),
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "排序",
              prop: "sort_order"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.itemForm.sort_order,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemForm.sort_order) = $event)),
                  min: 0,
                  max: 9999
                }, null, 8, ["modelValue"]),
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}